import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_SERVICE_URL
// axios.defaults.baseURL = 'https://test.b2bconecta.com/einvoice/rest-api/v1'
// axios.defaults.baseURL = 'https://dev-b2b-gcp.b2bconecta.com/einvoice/rest-api/v1'
// axios.defaults.baseURL = 'http://localhost:8081/einvoice/rest-api/v1'
// axios.defaults.baseURL = 'http://localhost:8008/einvoice/rest-api/v1'

